import type { Position } from "../Position.js";
import { careersPathMap } from "./careersPathMap.js";

export function getCareerDetailPath(position: Position): string {
	return `${careersPathMap[position.locale]}/${position.urlSlug}`;
}
